import { RemovePluginModal } from "./RemovePluginModal";

export default RemovePluginModal;
